export enum PushType {
  ORDER_STATUS_CHANGE = 'ORDER_STATUS_CHANGE',
  MESSAGE = 'MESSAGE',
  RESERVATION_REMINDER = 'RESERVATION_REMINDER',
  RESERVATION_STATUS_CHANGE = 'RESERVATION_STATUS_CHANGE',
  PAYMENT_STATUS_CHANGE = 'PAYMENT_STATUS_CHANGE',
  ORDER_REMINDER = 'ORDER_REMINDER',
  RESERVATION_UPDATED = 'RESERVATION_UPDATED',
}
